var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pulse"},_vm._l((3),function(i){return _c('span',{staticClass:"Pulse-ring"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }